import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
    const location = useLocation();
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const processedRef = useRef(false);
    const [status, setStatus] = useState("Signing you in…");

    useEffect(() => {
        if (processedRef.current) return;
        processedRef.current = true;
        const hash = location.hash || window.location.hash;
        const params = new URLSearchParams(hash.replace(/^#/, ""));
        const sessionId = params.get("session_id");
        if (!sessionId) {
            navigate("/login", { replace: true });
            return;
        }
        (async () => {
            try {
                const { data } = await api.post("/auth/google/session", { session_id: sessionId });
                setUser(data);
                // Clean the URL fragment
                window.history.replaceState({}, document.title, "/");
                // Restore deep-link target if one was stashed before the OAuth bounce.
                let target = "/app";
                try {
                    const stashed = sessionStorage.getItem("opencsv:post-login-target");
                    if (stashed) {
                        target = stashed;
                        sessionStorage.removeItem("opencsv:post-login-target");
                    }
                } catch {/* ignore */ }
                if (data.is_paid || data.role === "admin") {
                    navigate(target, { replace: true });
                } else {
                    // Force the $1 unlock — straight to Stripe, no detour. Keep the deep
                    // link in sessionStorage so PaymentSuccess can restore it.
                    try { sessionStorage.setItem("opencsv:post-login-target", target); } catch {/* ignore */ }
                    setStatus("Redirecting to checkout…");
                    const checkout = await api.post("/payments/checkout", { origin_url: window.location.origin });
                    window.location.href = checkout.data.url;
                }
            } catch (e) {
                setStatus(formatApiErrorDetail(e.response?.data?.detail) || "Sign-in failed. Please try again.");
                setTimeout(() => navigate("/login", { replace: true }), 2000);
            }
        })();
    }, [location.hash, navigate, setUser]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-paper" data-testid="auth-callback">
            <div className="text-center">
                <div className="ui-heading text-xs uppercase tracking-widest text-ink-muted mb-3">/ google sign in</div>
                <div className="font-display font-black text-3xl tracking-tighter">{status}</div>
            </div>
        </div>
    );
}
